import React from "react";

const Select = ({
  label,
  name,
  value = "",
  onChange,
  options = [],
  placeholder = "Select an option",
  error = "",
  helperText = "",
  required = false,
  disabled = false,
  className = "",
  ...props
}) => {
  const selectId = `select-${name}`;

  return (
    <div className={`ui-form-group ${className}`}>
      {label && (
        <label htmlFor={selectId} className="ui-form-label">
          {label}

          {required && (
            <span className="ui-form-required">*</span>
          )}
        </label>
      )}

      <select
        id={selectId}
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={`ui-select ${error ? "ui-select-error" : ""}`}
        aria-invalid={Boolean(error)}
        {...props}
      >
        <option value="">{placeholder}</option>

        {options.map((option) => {
          const optionValue =
            typeof option === "object"
              ? option.value
              : option;

          const optionLabel =
            typeof option === "object"
              ? option.label
              : option;

          return (
            <option
              key={optionValue}
              value={optionValue}
            >
              {optionLabel}
            </option>
          );
        })}
      </select>

      {error && (
        <p className="ui-form-error">
          {error}
        </p>
      )}

      {!error && helperText && (
        <p className="ui-form-helper">
          {helperText}
        </p>
      )}
    </div>
  );
};

export default Select;